import { createSlice } from "@reduxjs/toolkit";

// Slice для управления состоянием выбранного маркетплейса
export const MarketClient = createSlice({
    name: "marketclient",
    initialState: {
        market:undefined,
    },
    reducers: {
        onChangeMarketClient: (state, {payload}) => {
            state.market = payload.market;
            return state;
        },
    },

});

export const { onChangeMarketClient } = MarketClient.actions;
export const MarketClientSelector = (state) => state.marketclient;